import React, { useState } from 'react';

const CONSULT = [
  { t: 'First Consultation', sub: 'Nadi Pariksha + Prakriti Analysis + Treatment Plan', dur: 'Full Assessment' },
  { t: 'Follow-up Consultation', sub: 'Progress review, prescription update', dur: '30 min' },
  { t: 'Teleconsultation', sub: 'Online video consultation with prescription', dur: 'Virtual' }
];

const DAILY = [
  { t: 'Abhyanga + Steam — Full body oil massage with steam', dur: '60 min' },
  { t: 'Padabhyanga — Foot massage therapy', dur: '30 min' },
  { t: 'Shiro Abhyanga — Head oil massage', dur: '30 min' },
  { t: 'Udwartana + Steam — Herbal powder massage with steam', dur: '60 min' }
];

const HEAD_STRESS = [
  { t: 'Shirodhara (Takra/Oil) — Oil stream on forehead', dur: '45 min' },
  { t: 'Shiropichu — Medicated oil pooling on scalp', dur: '30 min' },
  { t: 'Shirovasti — Oil retention therapy for head', dur: '45 min' },
  { t: 'Nasya — Nasal therapy', dur: '30 min' },
  { t: 'Head-Neck-Shoulder Therapy — Targeted relief massage', dur: '30 min' }
];

const BASTI = [
  { t: 'Matra Basti — Mild medicated enema', dur: '—' },
  { t: 'Anuvasana Basti — Oil-based enema therapy', dur: '—' },
  { t: 'Kashaya Basti — Herbal decoction enema', dur: '—' },
  { t: 'Yoga Basti Package — 8-day Panchakarma Basti programme', dur: '8 days' },
  { t: 'Kati Basti — Localised oil pooling on lower back', dur: '45 min' },
  { t: 'Greeva Basti — Localised oil pooling on neck', dur: '45 min' },
  { t: 'Janu Basti — Localised oil pooling on knees', dur: '45 min' },
  { t: 'Netra Tarpana — Medicated ghee eye therapy', dur: '45 min' }
];

const KIZHI = [
  { t: 'Patra Pinda Sweda — Herbal leaf bundle massage', dur: 'Local / Full body' },
  { t: 'Choorna Pinda Sweda — Herbal powder bundle massage', dur: 'Local / Full body' },
  { t: 'Njavarakizhi — Medicated rice bundle massage', dur: 'Local / Full body' }
];

const PANCHAKARMA = [
  { t: 'Vamana — Therapeutic emesis (Kapha purge)', dur: 'Half day' },
  { t: 'Virechana — Purgation therapy (Pitta cleanse)', dur: 'Half day' },
  { t: 'Nasya Course — Extended nasal therapy course', dur: 'Course' }
];

const PRICE_NOTE = 'Personalised pricing based on your constitution & treatment duration — contact us for details';

function Table({ rows, consult }) {
  return (
    <table className="treat-table">
      <thead>
        <tr>
          <th>{consult ? 'Service' : 'Treatment'}</th>
          <th>{consult ? 'Details' : 'Duration'}</th>
          <th>Availability</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r, i) => (
          <tr key={i}>
            <td>
              <strong>{r.t.split(' — ')[0]}</strong>
              {r.sub && <><br /><span style={{ fontSize: 13, color: 'rgba(240,235,224,0.45)' }}>{r.sub}</span></>}
              {!r.sub && r.t.includes(' — ') && <span style={{ color: 'rgba(240,235,224,0.6)' }}> — {r.t.split(' — ')[1]}</span>}
            </td>
            <td className="duration-cell">{r.dur}</td>
            <td className="price-cell" style={{ fontSize: 12, color: 'rgba(240,235,224,0.55)', fontStyle: 'italic' }}>
              <a href="#appointment" style={{ color: 'var(--gold)', textDecoration: 'none', fontStyle: 'normal', fontSize: 12 }}>
                Contact clinic →
              </a>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

const TABS = [
  { key: 'consult', label: 'Consultations', rows: CONSULT, consult: true },
  { key: 'daily', label: 'Daily Therapies', rows: DAILY },
  { key: 'head_stress', label: 'Head & Stress Relief', rows: HEAD_STRESS },
  { key: 'basti', label: 'Basti Therapies', rows: BASTI },
  { key: 'kizhi', label: 'Kizhi Therapies', rows: KIZHI },
  { key: 'panchakarma', label: 'Panchakarma', rows: PANCHAKARMA }
];

export default function Treatments() {
  const [tab, setTab] = useState('consult');

  return (
    <section className="treatments" id="treatments" style={{ paddingTop: 72 }}>
      <div className="container">
        <div className="fade-up" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 32, flexWrap: 'wrap', gap: 24 }}>
          <div>
            <p className="section-label">Full Menu</p>
            <h2 className="section-title">Our <em>Treatments</em></h2>
          </div>
        </div>
        <p className="fade-up" style={{ color: 'rgba(240,235,224,0.6)', fontSize: 14, marginBottom: 32, fontStyle: 'italic' }}>
          ✦ {PRICE_NOTE}
        </p>
        <div className="treat-tabs fade-up">
          {TABS.map((tb) => (
            <button
              key={tb.key}
              className={`treat-tab ${tab === tb.key ? 'active' : ''}`}
              onClick={() => setTab(tb.key)}
            >
              {tb.label}
            </button>
          ))}
        </div>
        {TABS.map((tb) => (
          <div
            key={tb.key}
            className={`treat-panel fade-up ${tab === tb.key ? 'active' : ''}`}
            style={{ display: tab === tb.key ? 'block' : 'none' }}
          >
            <Table rows={tb.rows} consult={tb.consult} />
          </div>
        ))}
        <div className="fade-up" style={{ marginTop: 32, padding: '16px 24px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, textAlign: 'center' }}>
          <p style={{ color: 'rgba(240,235,224,0.7)', fontSize: 14 }}>
            Charges vary based on your Prakriti assessment and treatment plan, and our doctor will personalise a plan for you.
          </p>
        </div>
      </div>
    </section>
  );
}
